export const SexBodyTamplate = (rowData: any) => {
  return (
    <div className="flex align-items-center gap-2 w-full">
      <span>{!!rowData.sex ? rowData.sex.charAt(0).toUpperCase() : "-"}</span>
    </div>
  );
};
